module.exports = __webpack_public_path__ + "static/media/match-sample.ccf8e31d.png";